// extracted by mini-css-extract-plugin
export default {"root":"z2tPRhaqOYVw6nB0PGwk"};